import TriangleDodAsyncPlanner from "./TriangleDodAsyncPlanner";
import EliteWarRealtimePlanner from "./EliteWarRealtimePlanner";
import NationIntelRealtimePlanner from "./NationIntelRealtimePlanner";
import InfiniteZombiePlanner from "./InfiniteZombiePlanner";

const PLANNER_COMPONENTS = Object.freeze({
  triangleStrongholdPlanner: TriangleDodAsyncPlanner,
  eliteWarRealtimePlanner: EliteWarRealtimePlanner,
  nationIntelRealtimePlanner: NationIntelRealtimePlanner,
  infiniteZombiePlanner: InfiniteZombiePlanner,
});

export function getPlannerComponentByPlugin(pluginId = "") {
  return PLANNER_COMPONENTS[String(pluginId || "").trim()] || null;
}

